<template>
  <Modal :title="title" :showModal="showModal" class="edit-template-form large" @submit="submit">
    <template v-slot:body>
      <div class="choose-template position-relative w-100 mt-3 d-flex flex-wrap">
        <div class="position-relative form-group w-100">
          <label class="col-12 mb-0 p-0 font-weight-bold">Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="store.commit('name', $event.currentTarget.value)" />
        </div>
      </div>
      <component :is="modal" :config="modalConfig()"></component>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  data() {
    return {
      modal: null,
      /* prettier-ignore */
      submitStructure: [
        'name',
        'shared',
        'meta',
        'type'
      ]
    }
  },
  computed: {
    title() {
      return this.data.status == 'raw' ? 'Create Template' : 'Edit Template'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    templateId() {
      return this.config?.data?._id
    },
    getUri() {
      return `template/get/${this.templateId}`
    },
    submitUri() {
      return `template/update/${this.templateId}`
    },
    data() {
      return this.store.getter('', {})
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    modalConfig() {
      return {
        action: this.action,
        storeId: this.storeId,
        templateId: this.templateId
      }
    },
    setUpData(rawData) {
      let type = _.pascalCase(rawData.data.type || '')
      let action = _.pascalCase(this.action)
      let modal = `${type}.Template.${action}`
      if (this.$options.components[modal] == undefined) {
        this.$options.components[modal] = this.$util.requireOrNull(`.*/Template/Modal/More/${action}${type}.vue`)
      }
      if (rawData.status == 'success' && this.$options.components[modal] !== null) {
        this.store.commit('', rawData.data)
        this.modal = modal
        this.showModal = true
      } else {
        this.$emit('close')
        this.$util.notify({
          text: 'Type not supported!',
          status: 'error'
        })
      }
    },
    submit() {
      this.submitForm(this.data, {
        done: () => {
          this.$emit('closeAll')
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
